import 'react-datepicker/dist/react-datepicker.css';
import './toolbar.css';

import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import AuthComponent from '../../../../components/login/component/auth-provider';
import { Image } from 'react-bootstrap';
import RestEndPoint from '../../../RestEndPoint';
import logo from '../../../../images/Keyera-Logo.png';
import { withRouter } from 'react-router-dom';
import { AppConstants } from '../../../APIConstants';

@inject('AuthStore', 'CommonStore')
@observer
class Toolbar extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { CommonStore, AuthStore, history } = this.props;
    CommonStore.showLoader = true;
    AuthComponent.getReportToken().then((response) => {
      AuthStore.setAccessToken(response.accessToken);
    });

    AuthComponent.getRefreshReportToken().then((response) => {
      AuthStore.setRefreshReportToken(response.refreshReportToken);
    });

    AuthComponent.getUserNamePostLogin()
      .then(() => {
        CommonStore.getScreenWrappers();
        CommonStore.getReports();
        CommonStore.getScreens().then(() => {
          CommonStore.toggleLoader();

        }).catch(() => {
          window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
          CommonStore.toggleLoader();
        })
      })
      .catch(() => {
        window.toastr.error("Unable to authenticate user");
        history.push('/login');
        CommonStore.toggleLoader();
      });
  }

  render() {
    const { screenDetails, screenWrappers, reportDetails } = this.props.CommonStore;
    const activeScreenDetails = screenDetails.filter(screenDetail => screenDetail.screen.active);
    const nonWrapperScreens = activeScreenDetails.filter(screenDetail => !screenDetail.screen.navWrapper);
    const WrapperScreens = activeScreenDetails.filter(screenDetail => screenDetail.screen.navWrapper);
    const activeReportDetails = reportDetails.filter(reportDetail => reportDetail.screen.active);
    let customnonWrapperScreens = nonWrapperScreens.filter(item => item.screen.title !== "Products")
    return (
      <div>
        <div className="dont-print col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 navigation">
          <nav className="navbar navbar-expand-sm">
            <div className="container-fluid">
              <a className="navbar-brand" href="/">
                <Image src={logo} height="42" width="142px"  />
              </a>
              <div className="col-lg-1 col-xl-1 col-md-1 col-sm-12 col-xs-12 nav-title">
                {<h4>Reference Data Grid </h4>}
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6">
                <div
                  className="collapse navbar-collapse"
                  id="bs-example-navbar-collapse-1"
                >
                  <ul className="nav navbar-nav">
                    {screenDetails && screenDetails.length > 0 && (<li key="screens" className="nav-item dropdown">
                      <a
                        className="dropdown-toggle  dropdown-size"
                        href="#"
                        data-toggle="dropdown"
                      >
                        Screens<span className="caret"></span>
                      </a>
                      <div className="dropdown-menu">
                        {screenWrappers.map((wrapper) => (
                          this.renderChildWrapper(wrapper, WrapperScreens) //screen sub screen menu
                        ))}
                        {customnonWrapperScreens.map((screenDetail) => (
                          <a
                            key={screenDetail.screen.rowKey}
                            className="dropdown-item dropdown-size"
                            onClick={() =>
                              this.props.reportHandler(
                                'ReferenceData',
                                `/reference/${screenDetail.screen.name}`
                              )
                            }
                          >
                            {screenDetail.screen.title}
                          </a>
                        ))}
                      </div>
                    </li>)}
                    {reportDetails && reportDetails.length > 0 && (<li key="reports" className="nav-item dropdown">
                      <a
                        className="dropdown-toggle  dropdown-size"
                        href="#"
                        data-toggle="dropdown"
                      >
                        Reports<span className="caret"></span>
                      </a>
                      <div className="dropdown-menu">
                        {activeReportDetails.map((reportDetail) => (
                          <a
                            key={reportDetail.screen.rowKey}
                            className="dropdown-item dropdown-size"
                            onClick={() =>
                              this.props.reportHandler(
                                'ReferenceReport',
                                `/reference/${reportDetail.screen.name}`
                              )
                            }
                          >
                            {reportDetail.screen.title}
                          </a>
                        ))}
                      </div>
                    </li>)}
                  </ul>
                </div>
              </div>
              <div className="welcome-div col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                Welcome <b>|</b> {RestEndPoint.getCurrentUserName()} &nbsp;{' '}
                <a
                  onClick={() => this.handleLogOut()}
                  style={{ cursor: 'pointer', color: '#bdcbdc' }}
                >
                  <i className="fa fa-sign-out fontSize16px pl-10"></i>
                </a>
              </div>
            </div>
          </nav>
        </div>
      </div>
    );
  }

  renderChildWrapper = (wrapper, WrapperScreens) => {
    const screenDetailsObj = WrapperScreens.filter(screenDetail => screenDetail.screen.navWrapper === wrapper.rowKey)

    return screenDetailsObj && screenDetailsObj.length > 0 && (
      <div key={1 + Math.random() * (10000 - 1)} className="dropdown-submenu">
        <a href="#" className="dropdown-toggle dropdown-item dropdown-size dpdwn-navwrapper" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
          {wrapper.title}<span className="caret"></span></a>

        <ul className="dropdown-menu">
          {screenDetailsObj.map((screenDetail) => (
            <div key={screenDetail.screen.rowKey}>
              <a
                key={screenDetail.screen.rowKey}
                className="dropdown-item dropdown-size"
                onClick={() =>
                  this.props.reportHandler(
                    'ReferenceData',
                    `/reference/${screenDetail.screen.name}`
                  )
                }
              >
                {screenDetail.screen.title}
              </a>
            </div>))}
        </ul>
      </div>);
  }
  handleLogOut = () => {
    this.props.AuthStore.setLogOutItems();
    AuthComponent.onSignOut();
  };
}

export default withRouter(Toolbar);